//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { isDefined } from '@utils/filterPredicates';

// Copied from curalate-mobile

/**
 * Prepare a query string from a set of parameters.
 *
 * An undefined param set will return an empty string.
 * All non-string values will be `toString()`ed.
 * All `null | undefined` values will be filtered out.
 * All array values will be encoded as key=value1&key=value2
 *
 * e.g.
 * params({
 *   a: 'a',
 *   b: 2,
 *   c: undefined,
 *   d: null,
 *   e: ['dog', 'cat'],
 *   f: '',
 * })
 * produces:
 * 'a=a&b=2&e=dog&e=cat&f='
 *
 * @param paramsObj Key/Value store of query parameters
 */
export function makeParams(paramsObj?: Record<string, any>) {
  return isDefined(paramsObj)
    ? Object.entries(paramsObj)
        .filter(([, value]) => typeof value !== 'undefined' && value !== null)
        .map(([key, value]) => formatKeyValuePair(key, value))
        .join('&')
    : '';
}

function formatKeyValuePair(key: string, value: any): string {
  if (typeof value !== 'string' && Array.isArray(value)) {
    return Array.from(value)
      .map((val) => formatKeyValuePair(key, val))
      .join('&');
  }
  if (typeof value.toJSON === 'function') {
    value = value.toJSON();
  }

  if (
    typeof value === 'string' ||
    typeof value === 'boolean' ||
    typeof value === 'number'
  ) {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }

  return `${encodeURIComponent(key)}=${encodeURIComponent(
    JSON.stringify(value),
  )}`;
}
